import tw, { styled } from 'twin.macro';
import { ExternalLinkIcon } from '@components/Link/Link.styles';

export const Wrapper = styled.div`
  ${tw`inline-block`}
  ${tw`bg-neutrals-n4`}
  ${tw`py-3 px-6`}
  ${tw`rounded-[4px]`}
  ${tw`text-sm`}
  ${tw`font-medium`}
  ${tw`text-primary-purple`}
  ${tw`[box-shadow: 0px 2px 6px 1px rgba(41, 0, 66, 0.10)]`}

  a {
    ${tw`inline-block`}
    ${tw`uppercase tracking-[2.1px]`}
    ${tw`font-saira font-bold`}
    ${tw`whitespace-nowrap`}
    ${tw`after:[content:'_>'] md:hover:after:[content:'_-->']`}
    ${tw`text-secondary-s2-blue text-[14px]`}
    ${ExternalLinkIcon} {
      ${tw`hidden`}
    }
  }
`;

export const FeedbackRequest = styled.div`
  ${tw`flex flex-row justify-between items-center`}
  ${tw`gap-3`}
`;

export const Separator = styled.hr`
  ${tw`border-neutrals-n5`}
  ${tw`mt-10 mb-8`}
`;

export const Title = styled.h2`
  ${tw`text-neutrals-n9`}
  ${tw`text-md`}
  ${tw`font-bold`}
  ${tw`mb-6`}
`;

export const StyledButton = styled.button`
  ${tw`p-3`}
  ${tw`hover:bg-neutrals-n3`}

  &:active img {
    ${tw`[filter: invert(22%) sepia(86%) saturate(6553%) hue-rotate(279deg) brightness(32%) contrast(121%);]`}
  }
`;
